/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Nav_CompareInputs */

const en_fc_nav_compare = /** @type {(inputs: Fc_Nav_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Premiere Pro`)
};

/**
* | output |
* | --- |
* | "vs Premiere Pro" |
*
* @param {Fc_Nav_CompareInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_nav_compare = /** @type {((inputs?: Fc_Nav_CompareInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Nav_CompareInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_nav_compare(inputs)
});
export { fc_nav_compare as "fc.nav.compare" }